/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Button,
  Space,
  Input,
  message,
  Tooltip,
  Spin,
  DatePicker,
  Card,
  Select,
  Form,
  Col,
  Row,
} from "antd";
import {
  CloseOutlined,
  SearchOutlined,
  FilterOutlined,
  ClearOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import API from "../../../api";
import { APIs } from "../../../utils/worker";
import urls from "../../../api/urls";
import TableContainer from "../../../components/TableContainer";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { dateFormat_dmy } from "../../../utils";
import moment from "moment";
import SyncToOda from "../SyncToOda";
import { ReactComponent as Pfd_red_icon } from "../../../assests/images/SVG/pdf-red-icon.svg";
import useCustomNavigate from "../../../components/customNavigationHook";
import constants from "../../../constants/constants";
import "./style.scss";
const {
  DRS_LIST,
  DRS_AREA_LIST,
  DRS_DA_LIST,
  DRS_CREATE_API,
  DRS_PDF,
  DRS_PDF_V2,
  DRS_VALIDATE_AWB,
  DRS_VALIDATE_AWB_BULK,
} = urls;
const { RangePicker } = DatePicker;
const { ROLES } = constants;
const { DP_OPERATOR } = ROLES;

// Custom hook for barcode scanner detection
const useBarcodeScanner = (onScan, dependencies = []) => {
  const barcodeRef = useRef("");
  const intervalRef = useRef();

  const handleKeyDown = useCallback(
    (event) => {
      // If user is typing in an input field, don't interfere
      const target = event.target;
      const isEditableTarget =
        target &&
        (target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.isContentEditable);
      if (isEditableTarget) {
        return;
      }

      // Clear existing interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      // Handle Enter key - complete barcode scan
      if (event.code === "Enter") {
        if (barcodeRef.current.trim()) {
          onScan(barcodeRef.current.trim());
          barcodeRef.current = "";
        }
        return;
      }

      // Ignore all non-printable keys and special keys
      const ignoredKeys = [
        "Shift",
        "Control",
        "Alt",
        "Meta",
        "CapsLock",
        "NumLock",
        "ScrollLock",
        "Tab",
        "Escape",
        "F1",
        "F2",
        "F3",
        "F4",
        "F5",
        "F6",
        "F7",
        "F8",
        "F9",
        "F10",
        "F11",
        "F12",
        "Insert",
        "Delete",
        "Home",
        "End",
        "PageUp",
        "PageDown",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Pause",
        "PrintScreen",
        "ContextMenu",
      ];

      // Check if it's a special key or non-printable character
      if (
        ignoredKeys.includes(event.key) ||
        event.key.length > 1 || // Keys like "Enter", "Backspace", etc. have length > 1
        event.ctrlKey ||
        event.altKey ||
        event.metaKey
      ) {
        return;
      }

      // Only add printable alphanumeric characters
      if (event.key.length === 1 && /^[a-zA-Z0-9]$/.test(event.key)) {
        barcodeRef.current += event.key;
      }

      // Reset barcode after 50ms of inactivity (increased from 20ms for better reliability)
      intervalRef.current = setTimeout(() => {
        // If we have accumulated data but no Enter was pressed, treat as complete scan
        if (barcodeRef.current.trim()) {
          onScan(barcodeRef.current.trim());
        }
        barcodeRef.current = "";
      }, 50);
    },
    [onScan, ...dependencies],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [handleKeyDown]);
};

const DRSList = ({ hideCreateSection = false, defaultStatus = null }) => {
  const [form] = Form.useForm();
  const navigate = useCustomNavigate();
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [dataSource, setdataSource] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [originalTotal, setOriginalTotal] = useState();
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));

  // Function to check if current user is DP_OPERATOR
  const isDpOperator = () => {
    return userinfo?.roles && userinfo.roles.includes(DP_OPERATOR);
  };

  const [dateRange, setDateRange] = useState({
    startDate: moment(new Date(), dateFormat_dmy),
    dateFormat_dmy,
    endDate: moment(new Date(), dateFormat_dmy),
  });
  const today = moment().format(dateFormat_dmy);
  const [issueDate, setIssueDate] = useState(today);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState(null);
  const [documentNo, setDocumentNo] = useState("");
  const [documentNoArray, setDocumentNoArray] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [areaOptions, setAreaOptions] = useState([]);
  const [deliveryBoyOptions, setDeliveryBoyOptions] = useState([]);
  const [validatingAWBs, setValidatingAWBs] = useState(new Set());
  const [validatedAWBs, setValidatedAWBs] = useState([]);
  const [columnFilters, setColumnFilters] = useState({
    sewaSetuDrsNo: "",
    createdBy: "",
    status: "",
  });
  const [searchLoading, setSearchLoading] = useState({});
  const debounceRef = useRef({});
  const hasFetchedData = useRef(false);
  const selectedDeliveryBoyInfo = useRef(null);
  const role = userinfo?.roles[0];

  // Helper functions for localStorage
  const saveFormDataToLocalStorage = (key, value) => {
    if (!userinfo?.userId) return; // Don't save if no user ID
    const userSpecificKey = `drs_form_${userinfo?.userId}_${key}`;
    localStorage.setItem(userSpecificKey, JSON.stringify(value));
  };

  const getFormDataFromLocalStorage = (key) => {
    try {
      if (!userinfo?.userId) return null; // Don't load if no user ID
      const userSpecificKey = `drs_form_${userinfo?.userId}_${key}`;
      const saved = localStorage.getItem(userSpecificKey);
      if (!saved) return null;
      return JSON.parse(saved);
    } catch (error) {
      console.error("Error reading from localStorage:", error);
      return null;
    }
  };

  const clearFormDataFromLocalStorage = () => {
    if (!userinfo?.userId) return; // Don't clear if no user ID
    localStorage.removeItem(`drs_form_${userinfo?.userId}_selectedArea`);
    localStorage.removeItem(`drs_form_${userinfo?.userId}_selectedDeliveryBoy`);
    localStorage.removeItem(`drs_form_${userinfo?.userId}_documentNoArray`);
  };

  // Check for pre-selected AWBs from LockedShipments
  useEffect(() => {
    const processPassedAwbs = async () => {
      if (
        location.state?.selectedAwbNumbers &&
        location.state.selectedAwbNumbers.length > 0
      ) {
        const selectedAwbs = location.state.selectedAwbNumbers;

        // Clean input list
        const formattedInputs = selectedAwbs
          .map((doc) => doc?.toString().trim())
          .filter(Boolean);

        if (formattedInputs.length > 0) {
          setLoading(true); // Show loading while validating
          try {
            const validationResult = await validateAWBNumber(formattedInputs);

            if (validationResult?.validAwbs?.length > 0) {
              setDocumentNoArray(validationResult.validAwbs);
              // Also save to local storage just in case user refreshes immediately
              saveFormDataToLocalStorage(
                "documentNoArray",
                validationResult.validAwbs,
              );
            }
          } catch (error) {
            console.error("Error processing passed AWBs", error);
          } finally {
            setLoading(false);
          }
        }
      }
    };

    processPassedAwbs();
  }, [location.state]);

  // Load pre-selected data from local storage
  useEffect(() => {
    if (userinfo?.userId && !location.state?.selectedAwbNumbers) {
      const savedArea = getFormDataFromLocalStorage("selectedArea");
      const savedDeliveryBoy = getFormDataFromLocalStorage(
        "selectedDeliveryBoy",
      );
      const savedDocumentNoArray =
        getFormDataFromLocalStorage("documentNoArray");

      if (savedArea) setSelectedArea(savedArea);
      if (savedDeliveryBoy) setSelectedDeliveryBoy(savedDeliveryBoy);
      if (savedDocumentNoArray) {
        const formattedDocumentArray = savedDocumentNoArray
          .map((doc) => doc?.toString().trim())
          .filter(Boolean);
        setDocumentNoArray(formattedDocumentArray);
      }
    }
  }, [userinfo?.userId, location.state]);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getTableData();
      if (role !== DP_OPERATOR) {
        fetchDeliveryAreas();
      }
      fetchDeliveryAgents();
      hasFetchedData.current = true;
    }
  }, []);

  // Restore selectedDeliveryBoyInfo when delivery boy options are loaded
  useEffect(() => {
    if (selectedDeliveryBoy && deliveryBoyOptions.length > 0) {
      selectedDeliveryBoyInfo.current = deliveryBoyOptions.find(
        (option) => option.value === selectedDeliveryBoy,
      );
    }
  }, [selectedDeliveryBoy, deliveryBoyOptions]);

  // Cleanup debounce timeouts on unmount
  useEffect(() => {
    return () => {
      // Clear all pending debounce timeouts when component unmounts
      Object.values(debounceRef.current).forEach((timeout) => {
        if (timeout) clearTimeout(timeout);
      });
      debounceRef.current = {};
    };
  }, []);

  // Cleanup search loading states when column filters change externally
  useEffect(() => {
    // Clear any lingering search loading states that don't match current filters
    setSearchLoading((prev) => {
      const updated = { ...prev };
      Object.keys(updated).forEach((key) => {
        if (!columnFilters[key] || columnFilters[key] === "") {
          delete updated[key];
        }
      });
      return updated;
    });
  }, [columnFilters]);

  const getTableData = async (
    page = 1,
    pageSizeParam = 10,
    customParams = null,
    filters = null,
  ) => {
    const deliveryPartners =
      JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
    const cpId = userinfo?.spId ? userinfo?.spId : "";
    const dpId = deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";
    const idKey = role === DP_OPERATOR ? "dpId" : "cpId";
    const idValue = role === DP_OPERATOR ? dpId : cpId;

    // Prevent multiple simultaneous API calls
    if (loading) {
      console.log("API call already in progress, skipping...");
      return;
    }

    setLoading(true);
    try {
      let queryParams;

      if (customParams) {
        queryParams = customParams;
      } else {
        queryParams = new URLSearchParams({
          page: page.toString(),
          limit: pageSizeParam.toString(),
          startDate: moment(dateRange.startDate, dateFormat_dmy).format(
            "MM-DD-YYYY",
          ),
          endDate: moment(dateRange.endDate, dateFormat_dmy).format(
            "MM-DD-YYYY",
          ),
          ...(idValue && { [idKey]: idValue }),
          ...(defaultStatus && { status: defaultStatus }),
        });

        // Add column filters to query params if provided
        const filtersToUse = filters || columnFilters;
        Object.entries(filtersToUse).forEach(([columnKey, columnValue]) => {
          if (columnValue && columnValue.trim() !== "") {
            queryParams.set(columnKey, columnValue.trim());
          }
        });
      }

      const result = await API.Api(
        `${DRS_LIST}?${queryParams.toString()}`,
      ).get();
      const response = result?.response?.data;

      if (response?.status === 200) {
        // Always clear existing data and set new data to prevent showing stale data
        const newData = response.data.drsList || [];
        const totalCount = response?.data?.totalCount || 0;

        setTableData(newData);
        setdataSource(newData);
        setTotal(totalCount);
        setOriginalTotal(totalCount);
        setPageNum(page);
      } else {
        // Clear data on error to prevent showing stale data
        setTableData([]);
        setdataSource([]);
        setTotal(0);
        message.error(response?.message || "Failed to fetch DRS data");
      }
    } catch (error) {
      message.error(error?.message || "Error fetching DRS data");
      setTableData([]);
      setdataSource([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // Function to get delivery areas
  const getDeliveryAreas = async (userId) => {
    try {
      const response = await API.Api(`${DRS_AREA_LIST}?cpId=${userId}`).get();
      if (response.status) {
        return response.response.data.data; // Assuming the data is in this structure
      } else {
        throw new Error("Failed to fetch delivery areas");
      }
    } catch (error) {
      console.error("Error fetching delivery areas:", error);
      throw error; // Rethrow the error for further handling
    }
  };

  // Function to get delivery agents based on selected area
  const getDeliveryAgents = async () => {
    try {
      let paramKey = "";
      let paramValue = "";
      const deliveryPartners =
        JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
      const dpId = deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";
      if (role === DP_OPERATOR) {
        paramKey = "dpId";
        paramValue = dpId;
      } else {
        paramKey = "CpId";
        paramValue = userinfo?.spId;
      }
      if (!paramKey || !paramValue) throw new Error("User role or ID missing");
      const response = await API.Api(
        `${DRS_DA_LIST}?${paramKey}=${paramValue}`,
      ).get();
      if (response.status) {
        return response.response.data.data;
      } else {
        throw new Error("Failed to fetch delivery agents");
      }
    } catch (error) {
      console.error("Error fetching delivery agents:", error);
      throw error;
    }
  };

  // Function to create a new DRS entry
  const createDRS = async (payload) => {
    try {
      if (
        (role !== DP_OPERATOR && !payload.areaData) ||
        !payload.awbList ||
        !payload.daId
      ) {
        throw new Error("Please fill all the fields");
      }

      const response = await API.Api(DRS_CREATE_API).post(payload);
      if (response.status) {
        return response.response.data; // Assuming the data is in this structure
      } else {
        throw new Error(
          response?.response?.data?.message || "Failed to create DRS",
        );
      }
    } catch (error) {
      console.error("Error creating DRS:", error);
      throw error; // Rethrow the error for further handling
    }
  };

  const createDRSDirectly = async () => {
    try {
      setLoading(true);
      const selectedCompany = JSON.parse(
        localStorage.getItem("selectedCompany"),
      );
      const payload = {
        ...(role !== DP_OPERATOR && {
          areaData: {
            areaName: areaOptions.find((area) => area.value === selectedArea)
              ?.label,
            id: selectedArea,
          },
        }),
        awbList: documentNoArray,
        daId: selectedDeliveryBoyInfo.current.value,
        daMobileNo: selectedDeliveryBoyInfo.current.mobile,
        source: "NBA_WEB",
        companyId: selectedCompany?.key || selectedCompany?.newCompanyId,
        companyName: selectedCompany?.label,
      };

      const response = await createDRS(payload);
      message.success(response.message);
      // Reset form and clear localStorage
      setSelectedArea(null);
      setSelectedDeliveryBoy(null);
      setDocumentNo("");
      setDocumentNoArray([]);
      selectedDeliveryBoyInfo.current = null;
      clearFormDataFromLocalStorage();
      // Reset the Ant Design form
      form.resetFields();
      // Refresh table data
      getTableData();
    } catch (error) {
      message.error(error?.message || "Failed to create DRS");
    } finally {
      setLoading(false);
    }
  };

  const fetchDeliveryAreas = async () => {
    try {
      const areas = await getDeliveryAreas(userinfo?.spId);
      setAreaOptions(
        areas.map((area) => ({ value: area.areaId, label: area.name })),
      );
    } catch (error) {
      message.error("Failed to fetch delivery areas");
    }
  };

  const fetchDeliveryAgents = async () => {
    try {
      const agents = await getDeliveryAgents();
      setDeliveryBoyOptions(
        agents.map((agent) => ({
          value: agent._id,
          label: `${agent?.firstname} ${agent?.lastname} - ${agent.mobile}`,
          mobile: agent.mobile,
        })),
      );
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch delivery boys",
      );
    }
  };

  const handleDrsClick = (drsNo) => {
    window.open(`/cp-drs-details/${drsNo}`, "_blank");
  };

  const handleCreatePDF = async (record) => {
    try {
      setLoading(true);
      const apiUrl = `${DRS_PDF_V2}?DRS=${record.DRS_number}`;

      const response = await API.Api(apiUrl).get();

      if (response.status && response.response?.data?.data?.pdfUrlLink) {
        // Open the PDF URL in a new tab
        window.open(response.response.data.data.pdfUrlLink, "_blank");
      } else {
        message.error(
          response?.response?.data?.message || "Failed to generate PDF",
        );
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to generate PDF",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleColumnFilter = (value, field) => {
    // Create updated filters object immediately
    const updatedFilters = {
      ...columnFilters,
      [field]: value,
    };

    // Update the filter state immediately for UI responsiveness
    setColumnFilters(updatedFilters);

    // Reset pagination to first page when filtering
    setPageNum(1);

    // Clear existing timeout for this specific field
    if (debounceRef.current[field]) {
      clearTimeout(debounceRef.current[field]);
    }

    // Define minimum character requirements for different fields
    const getMinChars = (fieldName) => {
      if (fieldName === "sewaSetuDrsNo" || fieldName === "status") {
        return 2; // DRS Number and Status need at least 2 characters
      }
      return 3; // Created By needs at least 3 characters
    };

    const minChars = getMinChars(field);

    // Only proceed with API call if value meets minimum character requirement or is empty (for clearing)
    if (value === "" || value.length >= minChars) {
      // Set search loading state for this field
      setSearchLoading((prev) => ({
        ...prev,
        [field]: true,
      }));

      // Set new debounced timeout for this field (500ms delay)
      debounceRef.current[field] = setTimeout(() => {
        // Clear search loading state
        setSearchLoading((prev) => ({
          ...prev,
          [field]: false,
        }));

        // Call API with the specific updated filters to avoid stale closure
        getTableData(1, pageSize, null, updatedFilters);
      }, 500);
    } else {
      // Clear search loading state if validation fails
      setSearchLoading((prev) => ({
        ...prev,
        [field]: false,
      }));
    }
  };

  const handleClearFilters = () => {
    // Clear all existing debounce timeouts
    Object.values(debounceRef.current).forEach((timeout) => {
      if (timeout) clearTimeout(timeout);
    });
    debounceRef.current = {};

    // Clear search loading states
    setSearchLoading({});

    // Reset all column filters
    setColumnFilters({
      sewaSetuDrsNo: "",
      createdBy: "",
      status: "",
    });

    // Reset pagination to first page
    setPageNum(1);

    // Fetch data immediately without debounce (filters will be empty after reset)
    getTableData(1, pageSize, null, {
      sewaSetuDrsNo: "",
      createdBy: "",
      status: "",
    });
  };

  // Helper function to create column filter exactly like PRS Analytics
  const getColumnSearchProps = (dataIndex, placeholder) => {
    // Define minimum character requirements for different fields
    const getMinChars = (fieldName) => {
      if (fieldName === "sewaSetuDrsNo" || fieldName === "status") {
        return 2;
      }
      return 3;
    };

    const minChars = getMinChars(dataIndex);
    const placeholderText = `Search ${placeholder}...`;

    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={placeholderText}
            value={selectedKeys[0]}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedKeys(value ? [value] : []);
              handleColumnFilter(value, dataIndex);
            }}
            onPressEnter={() => {
              confirm();
              // Clear the debounce timeout to prevent double API call
              if (debounceRef.current[dataIndex]) {
                clearTimeout(debounceRef.current[dataIndex]);
                debounceRef.current[dataIndex] = null;
              }
              // Clear search loading state
              setSearchLoading((prev) => ({
                ...prev,
                [dataIndex]: false,
              }));
              // Trigger immediate API call with current filters
              getTableData(1, pageSize);
            }}
            style={{
              marginBottom: 8,
              display: "block",
              borderRadius: "6px",
            }}
            allowClear={false}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                confirm();
                // Clear the debounce timeout to prevent double API call
                if (debounceRef.current[dataIndex]) {
                  clearTimeout(debounceRef.current[dataIndex]);
                  debounceRef.current[dataIndex] = null;
                }
                // Clear search loading state
                setSearchLoading((prev) => ({
                  ...prev,
                  [dataIndex]: false,
                }));
                // Trigger immediate API call with current filters
                if (
                  selectedKeys[0] === "" ||
                  selectedKeys[0]?.length >= minChars
                ) {
                  getTableData(1, pageSize);
                }
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                setSelectedKeys([]);
                confirm(); // Close the filter popup
                // Clear debounce for this field
                if (debounceRef.current[dataIndex]) {
                  clearTimeout(debounceRef.current[dataIndex]);
                  debounceRef.current[dataIndex] = null;
                }
                // Clear search loading state
                setSearchLoading((prev) => ({
                  ...prev,
                  [dataIndex]: false,
                }));
                handleColumnFilter("", dataIndex);
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <div className={`filter-icon-container ${filtered ? "filtered" : ""}`}>
          <FilterOutlined
            className={`filter-icon ${filtered ? "filtered" : ""}`}
          />
        </div>
      ),
      filteredValue: columnFilters[dataIndex]
        ? [columnFilters[dataIndex]]
        : null,
    };
  };

  // Define the action column separately
  const actionColumn = {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title={"Download DRS PDF"} placement="bottom">
          <p
            className="pointer"
            style={{
              marginTop: "4px",
              marginBottom: "0",
              alignItems: "center",
            }}
            onClick={() => handleCreatePDF(record)}
          >
            <Pfd_red_icon />
          </p>
        </Tooltip>
      </Space>
    ),
    width: "60px",
  };

  const baseColumns = [
    {
      title: "SewaSetu DRS Number",
      dataIndex: "sewaSetuDrsNo",
      key: "drsNumber",
      width: 150,
      ...getColumnSearchProps("sewaSetuDrsNo", "SewaSetu DRS Number"),
    },
    {
      title: "DRS Number",
      dataIndex: "DRS_number",
      key: "DRS_number",
      render: (text, record) => (
        <a onClick={() => handleDrsClick(text)}>{text}</a>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
      ...getColumnSearchProps("createdBy", "Created By"),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "createdDate",
      render: (text) => {
        return moment(text).format(dateFormat_dmy + " hh:mm A") || "N/A";
      },
    },
    ...(!hideCreateSection
      ? [
          {
            title: "DRS Status",
            dataIndex: "status",
            key: "drsStatus",
            width: 100,
            ...getColumnSearchProps("status", "DRS Status"),
          },
        ]
      : [
          {
            title: "DRS Status",
            dataIndex: "status",
            key: "drsStatus",
            width: 100,
          },
        ]),
    {
      title: "No. of Shipments",
      dataIndex: "awbNumbers",
      width: 100,
      key: "awbNumbers",
      align: "center",
      render: (array) => {
        return array.length;
      },
    },
  ];

  // Conditionally combine columns based on user role
  const columns = isDpOperator() ? baseColumns : [...baseColumns, actionColumn];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const onSearch = async (e) => {
    setPageNum(1);
    const cpId = { cpId: userinfo?.spId ? userinfo?.spId : "" };

    if (e.target.value.length > 2) {
      let response = await API.Api(
        `${
          APIs.baseURL
        }/client-onboard/v1/client/search/${e.target.value.toLowerCase()}`,
      ).getCustomHeader({ ...cpId });
      if (response.status) {
        setTableData(response.response.data);
        setTotal(response.response.data.length);
      }
    } else {
      setTableData(dataSource);
      setTotal(originalTotal);
    }
  };

  const handlePageChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    const deliveryPartners =
      JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
    const cpId = userinfo?.spId ? userinfo?.spId : "";
    const dpId = deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";
    const idKey = role === DP_OPERATOR ? "dpId" : "cpId";
    const idValue = role === DP_OPERATOR ? dpId : cpId;

    // Create query params with correct date format
    const queryParams = new URLSearchParams({
      page: pagination.current.toString(),
      limit: pagination.pageSize.toString(),
      startDate: dateRange.startDate
        ? moment(dateRange.startDate, dateFormat_dmy).format("MM-DD-YYYY")
        : moment().format("MM-DD-YYYY"),
      endDate: dateRange.endDate
        ? moment(dateRange.endDate, dateFormat_dmy).format("MM-DD-YYYY")
        : moment().format("MM-DD-YYYY"),
      [idKey]: idValue,
      ...(defaultStatus && { status: defaultStatus }),
    });

    getTableData(pagination.current, pagination.pageSize, queryParams);
  };

  const handleDateChange = (dates) => {
    if (!dates) {
      // When dates are cleared
      setDateRange({
        startDate: null,
        endDate: null,
      });
      // Reset to page 1 when dates are cleared
      setPageNum(1);
      getTableData(1, pageSize);
      return;
    }

    if (dates[0] && dates[1]) {
      // When both dates are selected
      const newStartDate = moment(dates[0]).format(dateFormat_dmy);
      const newEndDate = moment(dates[1]).format(dateFormat_dmy);
      const deliveryPartners =
        JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
      const cpId = userinfo?.spId ? userinfo?.spId : "";
      const dpId = deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";
      const idKey = role === DP_OPERATOR ? "dpId" : "cpId";
      const idValue = role === DP_OPERATOR ? dpId : cpId;

      setDateRange({
        startDate: newStartDate,
        endDate: newEndDate,
      });

      const queryParams = new URLSearchParams({
        page: "1", // Always reset to page 1 when date changes
        limit: pageSize.toString(),
        startDate: dates[0].format("MM-DD-YYYY"),
        endDate: dates[1].format("MM-DD-YYYY"),
        [idKey]: idValue,
        ...(defaultStatus && { status: defaultStatus }),
      });

      // Reset to page 1 when date changes
      setPageNum(1);
      getTableData(1, pageSize, queryParams);
    }
  };

  const handleAreaChange = (value) => {
    setSelectedArea(value);
    saveFormDataToLocalStorage("selectedArea", value);
  };

  const handleDeliveryBoyChange = (value) => {
    setSelectedDeliveryBoy(value);
    saveFormDataToLocalStorage("selectedDeliveryBoy", value);
    selectedDeliveryBoyInfo.current = deliveryBoyOptions.find(
      (option) => option.value === value,
    );
  };

  // Function to check if all fields are filled
  const isFormValid = () => {
    return (
      issueDate &&
      (role === DP_OPERATOR || selectedArea) &&
      selectedDeliveryBoy &&
      documentNoArray.length > 0
    );
  };

  // Function to handle DRS creation
  const handleCreateDRS = async () => {
    // HERE I HAVE To WRITE LOGIC TO CREATE DRS DIRECTLY AND USING MODAL

    // setIsModalOpen(true);
    createDRSDirectly();
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
  };

  const handleModalSubmit = async () => {
    try {
      setLoading(true);
      const selectedCompany = JSON.parse(
        localStorage.getItem("selectedCompany"),
      );
      const payload = {
        ...(role !== DP_OPERATOR && {
          areaData: {
            areaName: areaOptions.find((area) => area.value === selectedArea)
              ?.label,
            id: selectedArea,
          },
        }),
        awbList: documentNoArray,
        daId: selectedDeliveryBoyInfo.current.value,
        daMobileNo: selectedDeliveryBoyInfo.current.mobile,
        source: "NBA_WEB",
        companyId: selectedCompany?.key || selectedCompany?.newCompanyId,
        companyName: selectedCompany?.label,
      };

      const response = await createDRS(payload);
      message.success(response.message);
      // Reset form and clear localStorage
      setSelectedArea(null);
      setSelectedDeliveryBoy(null);
      setDocumentNo("");
      setDocumentNoArray([]);
      selectedDeliveryBoyInfo.current = null;
      clearFormDataFromLocalStorage();
      // Reset the Ant Design form
      form.resetFields();
      // Refresh table data
      getTableData();
      setIsModalOpen(false);
    } catch (error) {
      message.error(error?.message || "Failed to create DRS");
      console.error("Create DRS Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const validateAWBNumber = async (rawAwbInputs) => {
    // Determine if input is array, if not modify to array
    const inputs = Array.isArray(rawAwbInputs) ? rawAwbInputs : [rawAwbInputs];

    // Clean all inputs
    const awbNumbers = inputs
      .map((awb) => awb?.toString().trim())
      .filter((awb) => awb); // Remove empty values

    if (awbNumbers.length === 0) return { validAwbs: [], invalidAwbs: [] };

    try {
      // Mark all as validating
      setValidatingAWBs((prev) => {
        const newSet = new Set(prev);
        awbNumbers.forEach((num) => newSet.add(num));
        return newSet;
      });

      const payload = {
        awbNos: awbNumbers,
      };

      let response;
      if (awbNumbers.length > 1) {
        response = await API.Api(DRS_VALIDATE_AWB_BULK).post(payload);
      } else {
        response = await API.Api(DRS_VALIDATE_AWB).post(payload);
      }

      if (response?.status && response?.response?.data?.status === 200) {
        const responseList = response?.response?.data?.data?.awbList || [];
        const validList = [];
        const invalidList = [];

        responseList.forEach((awbData) => {
          if (awbData && awbData.isValid) {
            validList.push(awbData.awbNo);

            // Add to validated list state if not already there
            setValidatedAWBs((prev) => {
              if (!prev.includes(awbData.awbNo)) {
                return [...prev, awbData.awbNo];
              }
              return prev;
            });
          } else {
            invalidList.push(awbData?.awbNo);
          }
        });

        // Show messages based on results
        if (validList.length > 0) {
          message.success(`${validList.length} AWB(s) validated successfully`);
        }
        if (invalidList.length > 0) {
          message.error(`${invalidList.length} AWB(s) are invalid`);
        }

        return { validAwbs: validList, invalidAwbs: invalidList };
      } else {
        message.error(
          response?.response?.data?.message || "Failed to validate AWBs",
        );
        return { validAwbs: [], invalidAwbs: awbNumbers };
      }
    } catch (error) {
      console.error("Error validating AWB:", error);
      message.error("Error validating AWB number(s). Please try again.");
      return { validAwbs: [], invalidAwbs: awbNumbers };
    } finally {
      // Remove from validating AWBs
      setValidatingAWBs((prev) => {
        const newSet = new Set(prev);
        awbNumbers.forEach((num) => newSet.delete(num));
        return newSet;
      });
    }
  };

  // Enhanced AWB handling with validation and deduplication
  const handleAWBScan = useCallback(
    async (rawAwbNumber) => {
      // Clean and validate AWB number
      const awbNumber = rawAwbNumber?.toString().trim();

      if (!awbNumber || awbNumber.length === 0) {
        message.error("Please enter a valid AWB number");
        return;
      }

      // Additional validation: check if AWB contains only alphanumeric characters
      const awbPattern = /^[A-Z0-9]+$/;
      if (!awbPattern.test(awbNumber)) {
        message.error("AWB number should contain only letters and numbers");
        return;
      }

      // Check for duplicates with consistent formatting
      const normalizedDocumentNoArray = documentNoArray.map((doc) =>
        doc.toString().trim(),
      );
      if (normalizedDocumentNoArray.includes(awbNumber)) {
        message.warning(`AWB ${awbNumber} has already been added`);
        setDocumentNo("");
        saveFormDataToLocalStorage("documentNo", "");
        return;
      }

      // Show loading state
      setLoading(true);

      try {
        // Validate the AWB number
        const validationResult = await validateAWBNumber(awbNumber);

        // Since we scanned one, we check if it's in the valid list
        if (validationResult?.validAwbs?.length > 0) {
          const validatedAwbNo = validationResult.validAwbs[0]
            .toString()
            .trim();

          // Double-check for duplicates with the validated AWB number
          const normalizedArray = documentNoArray.map((doc) =>
            doc.toString().trim(),
          );
          if (!normalizedArray.includes(validatedAwbNo)) {
            const newArray = [...documentNoArray, validatedAwbNo];
            setDocumentNoArray(newArray);
            saveFormDataToLocalStorage("documentNoArray", newArray);
          }

          // Clear the input field
          setDocumentNo("");
          saveFormDataToLocalStorage("documentNo", "");
        }
      } catch (error) {
        console.error("Error in document validation:", error);
        message.error("Failed to process document number");
      } finally {
        setLoading(false);
      }
    },
    [documentNoArray, validateAWBNumber, saveFormDataToLocalStorage],
  );

  // Set up barcode scanner after handleAWBScan is defined
  useBarcodeScanner(handleAWBScan, [handleAWBScan]);

  const handleDocumentNoKeyPress = async (e) => {
    if (e.key === "Enter" && documentNo.trim() !== "") {
      await handleAWBScan(documentNo);
    }
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="master-main-container m-1 mt-3 p-1 drs-list-container">
        {/* Create DRS Card */}
        {!hideCreateSection && (
          <Card
            title="Create DRS"
            className="mb-4"
            style={{ marginBottom: "24px" }}
          >
            <Form form={form} layout="vertical">
              <Row gutter={[16, 16]}>
                <Col lg={8} md={12} xs={24}>
                  <label>Issue Date</label>
                  <Input
                    disabled
                    value={issueDate}
                    className="input-field-style w-100"
                  />
                </Col>

                {role !== DP_OPERATOR && (
                  <Col lg={8} md={12} xs={24}>
                    <Form.Item
                      label="Select Area"
                      name="area"
                      labelCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Please select an area",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select Area"
                        value={selectedArea}
                        onChange={handleAreaChange}
                        options={areaOptions}
                        style={{ height: "40px" }}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                )}

                <Col lg={8} md={12} xs={24}>
                  <Form.Item
                    name="deliveryBoy"
                    label="Select Delivery Boy"
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: true,
                        message: "Please select a delivery boy",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Delivery Boy"
                      value={selectedDeliveryBoy}
                      onChange={handleDeliveryBoyChange}
                      options={deliveryBoyOptions}
                      style={{ height: "40px" }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      notFoundContent="No delivery boy found"
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Document No"
                    name="documentNo"
                    labelCol={{ span: 24 }}
                  >
                    <div>
                      <Input
                        placeholder="Enter Document No (or scan barcode)"
                        value={documentNo}
                        onChange={(e) => {
                          // Clean input - remove special characters and normalize case
                          const cleanedValue = e.target.value.replace(
                            /[^a-zA-Z0-9]/g,
                            "",
                          );
                          setDocumentNo(cleanedValue);
                          saveFormDataToLocalStorage(
                            "documentNo",
                            cleanedValue,
                          );
                        }}
                        onKeyPress={handleDocumentNoKeyPress}
                        className="input-field-style"
                        style={{ height: "40px" }}
                        maxLength={18}
                      />
                      <div
                        style={{
                          marginTop: "10px",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        {documentNoArray.map((docNo, index) => (
                          <span key={index} className="chip">
                            {docNo}
                            <CloseOutlined
                              onClick={() => {
                                const newArray = documentNoArray.filter(
                                  (_, i) => i !== index,
                                );
                                setDocumentNoArray(newArray);
                                saveFormDataToLocalStorage(
                                  "documentNoArray",
                                  newArray,
                                );
                              }}
                              style={{ marginLeft: "5px", cursor: "pointer" }}
                            />
                          </span>
                        ))}
                      </div>
                    </div>
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="end" align="middle" gutter={[16, 0]}>
                {documentNoArray.length > 0 && (
                  <Col>
                    <div style={{ color: "#1890ff", fontWeight: "bold" }}>
                      Total Documents: {documentNoArray.length}
                    </div>
                  </Col>
                )}
                <Col>
                  <Form.Item>
                    <Button
                      type="primary"
                      disabled={!isFormValid()}
                      onClick={handleCreateDRS}
                      style={{
                        height: "40px",
                        minWidth: "120px",
                      }}
                    >
                      Create DRS
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        )}

        {/* Manage DRS Card */}
        <Card title="Manage DRS" style={{ marginTop: "24px" }}>
          <label>Select Date Range:</label>
          <div style={{ marginBottom: "4px", marginTop: "4px" }}>
            <RangePicker
              value={
                dateRange.startDate && dateRange.endDate
                  ? [
                      moment(dateRange.startDate, dateFormat_dmy),
                      moment(dateRange.endDate, dateFormat_dmy),
                    ]
                  : null
              }
              format={dateFormat_dmy}
              onClick={(e) => e.stopPropagation()}
              onChange={handleDateChange}
              disabledDate={(current) =>
                current && current > moment().endOf("day")
              }
              className="input-field-style"
              style={{ width: "225px" }}
            />
          </div>

          <Row justify="end" align="middle" className="mb-1 mr-1">
            <Col>
              <Button
                type="default"
                icon={<ClearOutlined />}
                onClick={handleClearFilters}
                disabled={
                  Object.values(columnFilters).filter(
                    (value) => value && value.trim() !== "",
                  ).length === 0
                }
              >
                Clear Filters{" "}
                {Object.values(columnFilters).filter(
                  (value) => value && value.trim() !== "",
                ).length > 0 &&
                  `(${
                    Object.values(columnFilters).filter(
                      (value) => value && value.trim() !== "",
                    ).length
                  })`}
              </Button>
            </Col>
          </Row>

          <TableContainer
            columns={columns}
            dataSource={tableData}
            pagination={{
              pageSize: pageSize,
              total: total,
              itemRender: itemRender,
              current: pageNum == 0 ? +1 : pageNum,
            }}
            onChange={handlePageChange}
          />
        </Card>

        <SyncToOda
          visible={isModalOpen}
          onCancel={handleModalCancel}
          onSubmit={handleModalSubmit}
          loading={loading}
        />
      </div>
    </Spin>
  );
};

export default DRSList;
